var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.09,
    height: 29.901,
    viewBox: "0 0 27.09 29.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_notification_1334828",
    transform: "translate(1.011 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M34.705,17.168a9.452,9.452,0,0,0-9.54-8.888h-.207a9.445,9.445,0,0,0-9.547,8.881v6.507a9.477,9.477,0,0,1-.956,4.136l-1.9,3.845a.334.334,0,0,0,.3.482h8.206v.05a4.013,4.013,0,0,0,3.993,4h0a3.993,3.993,0,0,0,3.979-3.989v-.05H37.25a.334.334,0,0,0,.3-.482L35.668,27.8a9.477,9.477,0,0,1-.953-4.136V17.65Q34.719,17.412,34.705,17.168ZM28.352,32.192l-6.621,0Z",
    transform: "translate(-12.518 -8.28)",
    fill: "none",
    stroke: "#202121",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.f3522ba9d58c124c6d1595b5450a04c5.svg";
export { ForwardRef as ReactComponent };